import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Landing = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const executeScroll1 = () => document.getElementById('anchor-name').scrollIntoView();
    const executeScroll2 = () => document.getElementById('anchor-name2').scrollIntoView();

    //const data = ["Block1","Block2","Block3","Block4"]
    const data = ["Block1","Block2","Block3"]
    const [currentIndex, setCurrentIndex] = useState(0)
    const [Interrupt, setInterrupt] = useState(false)
    const [Name, setName] = useState("")
    const [Company, setCompany] = useState("")
    const [Workers, setWorkers] = useState("")
    const [Email, setEmail] = useState("")
    const [Phone, setPhone] = useState("")

    const [TaskStart, setTaskStart] = useState(false)
    const [TaskDone, setTaskDone] = useState(false)

    const [validation, setvalidation] = useState({
        "Name" : "valid",
        "Company" : "valid",
        "Workers" : "valid",
        "Email" : "valid",
        "Phone" : "valid",
    });

    const carouselInfiniteScroll = () => {
        if(currentIndex === data.length - 1) {
            return changePageManually(0,false)
        }
        return changePageManually(currentIndex+1,false)
    }

    useEffect(() => {
        const interval = setInterval(() => {carouselInfiniteScroll()}, 15000)
        if(Interrupt) {
            setInterrupt(false)
            return clearInterval(interval)
        }
        return () => clearInterval(interval)
    })

    function changePageManually(page,interrupt=true) {
        if(interrupt) setInterrupt(true)
        setCurrentIndex(page)
        let blocks = document.getElementsByClassName("LandingInnerFourthBlock")
        for(let i=0; i<blocks.length; i++) {
            if(page !== i && !blocks[i].className.includes("LandingInnerFourthBlockHidden")) {
                blocks[i].className += " LandingInnerFourthBlockHidden"
            }
            if(page === i && blocks[i].className.includes("LandingInnerFourthBlockHidden")) {
                blocks[i].className =  blocks[i].className.replace(" LandingInnerFourthBlockHidden", "")
            }
        }
    }

    const handleName = (value) => {
        const result = value.replace(/\d/g, '');
        setName(result);
    };

    const handleChange = (value, setValue) => {
        const result = value.replace(/\D/g, '');
        setValue(result.slice(0, 5));
    };

    const sendContact = async() => {
        if(window.innerWidth >= 400) {
            MySwal.fire({
              position: "center",
              iconColor: "#6633FF",
              imageUrl: "https://static.yomecontrolo.cl/public/icons/ymc-loading.gif",
              title: "Enviando...",
              color: "#340066",
              imageWidth: 400,
              imageHeight: 400,
              showConfirmButton: false,
            })
        } else {
            MySwal.fire({
              position: "center",
              iconColor: "#6633FF",
              imageUrl: "https://static.yomecontrolo.cl/public/icons/ymc-loading.gif",
              title: "Enviando...",
              color: "#340066",
              imageWidth: 280,
              imageHeight: 280,
              showConfirmButton: false,
            })
        }

        var params = {
            name: Name,
            company: Company,
            workers: Workers,
            email: Email,
            tel: Phone
        };
      
        var requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params)
        };
    
        try{
          
        const resp = await fetch("https://ymc-doc-api.azurewebsites.net/sendcompanycontactmail", requestOptions)
         if (resp.status !== 200){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al enviar el correo",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
        }
    
            setTaskDone(true)
            setTaskStart(false)
            MySwal.fire({
                icon: "success",
                iconColor: "#6633FF",
                title: "Se ha enviado el correo de contacto",
                showConfirmButton: false,
                timer: 1500
            });
        }
        catch(error){
            //console.log("there has been an error login in")
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al enviar el correo",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false
        }
    }

    const verifyContact = () => {
        let validRegexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let validRegexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;

        let isNameValid = Name.length === 0 ? "invalid" : Name.trim() === "" ? "invalid" : "valid";
        let isCompanyValid = Company.length === 0 ? "invalid" : Company.trim() === "" ? "invalid" : "valid";
        let isWorkersValid = Workers.length === 0 ? "invalid" : parseInt(Workers) === 0 ? "invalid" : "valid"

        let isEmailValid = "valid"
        if(!Email.match(validRegexEmail)) {
            isEmailValid = "invalid"
        } 
        let isPhoneValid = "valid"
        if(!Phone.match(validRegexPhone) || Phone.length < 9 || Phone.length > 11) {
            isPhoneValid = "invalid"
        }

        setvalidation({
            "Name" : isNameValid,
            "Company" : isCompanyValid,
            "Workers" : isWorkersValid,
            "Email" : isEmailValid,
            "Phone" : isPhoneValid,
        });

        if(![isNameValid,isCompanyValid,isWorkersValid,isEmailValid,isPhoneValid].includes("invalid")) {
            sendContact()
        }
    }

    return (
        <div className='LandingFull'>
            <div className='LandingInnerDiv'>
                <div className='LandingInnerFirstBlock'>
                    <div className='LandingInnerFirstBlockUpper'>
                        <div className='LandingInnerFirstBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Programas de Salud Laboral +YMC</div>
                            <h1 className='LandingInnerFirstBlockTitle'>El camino hacia un entorno laboral más saludable junto a <span style={{fontWeight:"900"}} >+ymc</span></h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Un compromiso con el bienestar y la productividad. 
                            <br />En el mundo empresarial actual, caracterizado por jornadas largas, estrés constante y el predominio del sedentarismo, la salud de los empleados se ha convertido en un factor clave para garantizar la sostenibilidad y el éxito de cualquier organización.</div>
                        </div>
                        <div className='LandingInnerFirstBlockRight'>
                            <div className='GeneralPurpleButtonFlex LandingInnerFirstBlockRightButtonFlex' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='LandingInnerFirstBlockLower' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/companies/LandingFirstBanner.jpg')",backgroundPosition: 'center top',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                </div>
                <div className='LandingInnerSecondBlock'>
                    <div className='LandingInnerFirstBlockUpper'>
                        <div className='LandingInnerFirstBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>¿Por qué elegirnos?</div>
                            <h1 className='LandingInnerFirstBlockTitle'>Prevenir hoy es proteger el futuro de tu empresa y trabajadores</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>En Chile, las enfermedades cardiovasculares son la principal causa de muerte, responsables del 28% de los decesos y  representan una amenaza crítica en el entorno laboral, donde factores como el estrés, el sedentarismo y  estilos de vida poco saludables presentan un riesgo para los colaboradores.</div>
                        </div>
                        <div className='LandingInnerFirstBlockRight'>
                            <div className='GeneralPurpleButtonFlex LandingInnerFirstBlockRightButtonFlex' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='LandingInnerSecondBlockLowerFlexOuter'>
                        <div className='LandingInnerSecondBlockLowerFlex'>
                            <div className='LandingInnerSecondBlockLowerFlexBlock'>
                                <img className='LandingInnerSecondBlockLowerFlexBlockImage' src="https://static.yomecontrolo.cl/public/companies/LandingCircleIcon1.png" />
                                <div className='LandingInnerSecondBlockLowerFlexBlockLowerText'>Reducción de costos médicos.</div>
                            </div>
                            <div className='LandingInnerSecondBlockLowerFlexBlock'>
                                <img className='LandingInnerSecondBlockLowerFlexBlockImage' src="https://static.yomecontrolo.cl/public/companies/LandingCircleIcon2.png" />
                                <div className='LandingInnerSecondBlockLowerFlexBlockLowerText'>Cumplimiento del Decreto 44 y normativas internacionales.</div>
                            </div>
                            <div className='LandingInnerSecondBlockLowerFlexBlock'>
                                <img className='LandingInnerSecondBlockLowerFlexBlockImage' src="https://static.yomecontrolo.cl/public/companies/LandingCircleIcon3.png" />
                                <div className='LandingInnerSecondBlockLowerFlexBlockLowerText'>Incremento de la productividad y bienestar laboral.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='LandingInnerThirdBlock'>
                    <div className='LandingInnerFirstBlockUpper'>
                        <div className='LandingInnerFirstBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Servicios para tu empresa</div>
                            <h1 className='LandingInnerFirstBlockTitle'>Soluciones para impulsar un entorno laboral más saludable</h1>
                        </div>
                        <div className='LandingInnerFirstBlockRight'>
                            <div className='GeneralPurpleButtonFlex LandingInnerFirstBlockRightButtonFlex' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='LandingInnerThirdBlockLowerFlex'>
                        <div className='LandingInnerThirdBlockLowerFlexBlock' onClick={() => {changePageManually(0); executeScroll1()}}>
                            <img className='LandingInnerThirdBlockLowerFlexBlockImageBlock' src="https://static.yomecontrolo.cl/public/companies/SolutionsImage1.jpg" />
                            <div className='LandingInnerThirdBlockLowerFlexBlockLowerTexts'>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerTitle'>Programa de Salud Cardio-Metabólica</div>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerSubtitle'>Evaluaciones de salud en terreno con foco en la detección temprana de enfermedades cardiometabólicas como la hipertensión, diabetes, obesidad y sus complicaciones.</div>
                            </div>
                        </div>
                        <div className='LandingInnerThirdBlockLowerFlexBlock' onClick={() => {changePageManually(1); executeScroll1()}}>
                            <img className='LandingInnerThirdBlockLowerFlexBlockImageBlock' src="https://static.yomecontrolo.cl/public/companies/SolutionsImage2.jpg" />
                            <div className='LandingInnerThirdBlockLowerFlexBlockLowerTexts'>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerTitle'>Programa de Salud Auditiva</div>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerSubtitle'>Diagnósticos en terreno con el Bus de Audionautas.<br />Audiometrías, consultas especializadas y derivaciones GES.</div>
                            </div>
                        </div>
                        <div className='LandingInnerThirdBlockLowerFlexBlock' onClick={() => {changePageManually(2); executeScroll1()}}>
                            <img className='LandingInnerThirdBlockLowerFlexBlockImageBlock' src="https://static.yomecontrolo.cl/public/companies/SolutionsImage3.jpg" />
                            <div className='LandingInnerThirdBlockLowerFlexBlockLowerTexts'>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerTitle'>Clínicas Móviles en Terreno</div>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerSubtitle'>Evaluaciones de salud directamente en el lugar de trabajo.<br />Equipos médicos especializados para intervenciones rápidas y efectivas.</div>
                            </div>
                        </div>
                        {/* 
                        <div className='LandingInnerThirdBlockLowerFlexBlock' onClick={() => {changePageManually(3); executeScroll1()}}>
                            <img className='LandingInnerThirdBlockLowerFlexBlockImageBlock' src="https://static.yomecontrolo.cl/public/companies/SolutionsImage4.jpg" />
                            <div className='LandingInnerThirdBlockLowerFlexBlockLowerTexts'>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerTitle'>Visualizador de Salud Corporativa</div>
                                <div className='LandingInnerThirdBlockLowerFlexBlockLowerSubtitle'>Plataforma digital para monitorear el estado de salud de los colaboradores.<br />Informes dinámicos y segmentación por niveles de riesgo.</div>
                            </div>
                        </div>*/}
                    </div>
                </div>
                <div style={{position: "relative"}}>
                    <div id="anchor-name" style={{position: "absolute", top: "-20px", left: 0}}></div>
                </div>
                <div className='LandingInnerFourthBlockCarousel'>
                    <div className='LandingInnerFourthBlock' id="Block1" style={{transform:"translate(-"+(currentIndex * 100)+"%)"}}>
                        <div className='LandingInnerFourthBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Detalle de Servicio</div>
                            <div className='LandingInnerFourthBlockPageFlex'>
                                <div className='LandingInnerFourthBlockPageFlexActivePage'></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(1)}></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(2)}></div>
                                {/*<div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(3)}></div>*/}
                            </div>
                            <h1 className='LandingInnerFirstBlockTitle'>Programa de Salud Cardio-Metabólica para el Trabajador</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Dale a tus trabajadores la capacidad de tomar el control de su salud & bienestar en sus propias manos usando la combinación entre ciencia y tecnología que te ofrece +ymc para alcanzar etornos laborales más saludables y seguros.
                                <br />Ofrecemos:
                                <br />Evaluaciones de riesgos cardiovasculares, metabólicos y físicos.
                                <br />Emisión automática de órdenes médicas y talleres educativos.</div>
                                <div className='GeneralWhiteButtonFlex LandingInnerFirstBlockRightButtonFlex2' onClick={() => executeScroll2() }>
                                    <div className='LandingInnerFirstBlockRightButtonLeft'>
                                        Contáctanos
                                    </div>
                                    <div className="LandingInnerFirstBlockRightButtonRight2">
                                        <FontAwesomeIcon 
                                            icon={faArrowRightLong} 
                                            className='LandingInnerFirstBlockRightButtonRightImage'
                                        />
                                    </div>
                                </div>
                        </div>
                        <img className='LandingInnerFourthBlockRight' src="https://static.yomecontrolo.cl/public/companies/SafetyProgramImage.jpg" />
                    </div>
                    <div className='LandingInnerFourthBlock' id="Block2" style={{transform:"translate(-"+(currentIndex * 100)+"%)"}}>
                        <div className='LandingInnerFourthBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Detalle de Servicio</div>
                            <div className='LandingInnerFourthBlockPageFlex'>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(0)}></div>
                                <div className='LandingInnerFourthBlockPageFlexActivePage'></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(2)}></div>
                                {/*<div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(3)}></div>*/}
                            </div>
                            <h1 className='LandingInnerFirstBlockTitle'>Programa de Salud Auditiva para colaboradores</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Nos enorgullece ser la propuesta más integral en Chile para programas garantizando un cuidado completo y eficiente de la salud auditiva en el ámbito laboral.
                                <br /><br />Ofrecemos: 
                                <br /><br />Consulta Otorrinolaringología
                                <br />Evaluación auditiva
                                <br />Examen de Audiometrías
                                <br />Derivación GES para audífono (+65)
                                <br />Plataforma de Seguimiento Histórico
                                <br />Programa de Alfabetización personalizado</div>
                            <div className='GeneralWhiteButtonFlex LandingInnerFirstBlockRightButtonFlex2' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight2">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                        <img className='LandingInnerFourthBlockRight' src="https://static.yomecontrolo.cl/public/companies/SafetyProgramImage2.jpg" />
                    </div>
                    <div className='LandingInnerFourthBlock' id="Block3" style={{transform:"translate(-"+(currentIndex * 100)+"%)"}}>
                        <div className='LandingInnerFourthBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Detalle de Servicio</div>
                            <div className='LandingInnerFourthBlockPageFlex'>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(0)}></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(1)}></div>
                                <div className='LandingInnerFourthBlockPageFlexActivePage'></div>
                                {/*<div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(3)}></div>*/}
                            </div>
                            <h1 className='LandingInnerFirstBlockTitle'>Clínicas Móviles en Terreno</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Evaluaciones de salud directamente en el lugar de trabajo.
                                <br />Equipos médicos especializados para intervenciones rápidas y efectivas.</div>
                            <div className='GeneralWhiteButtonFlex LandingInnerFirstBlockRightButtonFlex2' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight2">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                        <img className='LandingInnerFourthBlockRight' src="https://static.yomecontrolo.cl/public/companies/SafetyProgramImage3.jpg" />
                    </div>
                    {/* 
                    <div className='LandingInnerFourthBlock' id="Block4" style={{transform:"translate(-"+(currentIndex * 100)+"%)"}}>
                        <div className='LandingInnerFourthBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>Detalle de Servicio</div>
                            <div className='LandingInnerFourthBlockPageFlex'>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(0)}></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(1)}></div>
                                <div className='LandingInnerFourthBlockPageFlexInactivePage' onClick={() => changePageManually(2)}></div>
                                <div className='LandingInnerFourthBlockPageFlexActivePage'></div>
                            </div>
                            <h1 className='LandingInnerFirstBlockTitle'>Visualizador de Salud Corporativa</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Plataforma digital para monitorear el estado de salud de los colaboradores.
                                <br />Informes dinámicos y segmentación por niveles de riesgo.</div>
                                <div className='GeneralWhiteButtonFlex LandingInnerFirstBlockRightButtonFlex2' onClick={() => executeScroll2() }>
                                    <div className='LandingInnerFirstBlockRightButtonLeft'>
                                        Contáctanos
                                    </div>
                                    <div className="LandingInnerFirstBlockRightButtonRight2">
                                        <FontAwesomeIcon 
                                            icon={faArrowRightLong} 
                                            className='LandingInnerFirstBlockRightButtonRightImage'
                                        />
                                    </div>
                                </div>
                        </div>
                        <img className='LandingInnerFourthBlockRight' src="https://static.yomecontrolo.cl/public/companies/SafetyProgramImage4.jpg" />
                    </div>
                    */}
                </div>
                <div className='LandingInnerFifthBlock'>
                    <div className='LandingInnerFirstBlockUpper'>
                        <div className='LandingInnerFirstBlockLeft'>
                            <div className='LandingInnerFirstBlockUpTitle'>¿Por qué +ymc?</div>
                            <h1 className='LandingInnerFirstBlockTitle'>Te ayudamos a impulsar medidas saludables y acceso a una medicina preventiva oportuna y eficaz</h1>
                            <div className='LandingInnerFirstBlockSubtitle'>Se puede reducir la exposición de los trabajadores a las enfermedades cardiovasculares como infarto y ACV.</div>
                        </div>
                        <div className='LandingInnerFirstBlockRight'>
                            <div className='GeneralPurpleButtonFlex LandingInnerFirstBlockRightButtonFlex' onClick={() => executeScroll2() }>
                                <div className='LandingInnerFirstBlockRightButtonLeft'>
                                    Contáctanos
                                </div>
                                <div className="LandingInnerFirstBlockRightButtonRight">
                                    <FontAwesomeIcon 
                                        icon={faArrowRightLong} 
                                        className='LandingInnerFirstBlockRightButtonRightImage'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='LandingInnerFifthBlockLower' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/companies/LandingSecondBanner.jpg')",backgroundPosition: 'center top',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}></div>
                </div>
                <div style={{position: "relative"}}>
                    <div id="anchor-name2" style={{position: "absolute", top: "-20px", left: 0}}></div>
                </div>
                <div className='LandingInnerSixthBlockOuter'>
                    <div className='LandingInnerSixthBlock'>
                        <div className='LandingInnerSixthBlockLeft'>
                            <img className='LandingInnerSixthBlockLeftImage' src="https://static.yomecontrolo.cl/public/companies/WhitePlusIcon.svg" />
                        </div>
                        <div className='LandingInnerSixthBlockRight'>
                            <div className='LandingInnerFirstBlockUpTitle'>Contáctanos</div>
                            <h3 className='LandingInnerFirstBlockTitle'>Estamos aquí para ayudarte con tus dudas</h3>
                            <div className='LandingInnerSixthBlockRightSubtitle'>Te ayudaremos a impulsar el bienestar de tus colaboradores con programas de salud laboral personalizados que mejoran la calidad de vida. Hablemos sobre tu empresa y tus objetivos.</div>
                            <div className='LandingInnerSixthBlockRightNotice'>* Obligatorios</div>
                            <div className='LandingInnerSixthBlockRightInputTitle'>Tu nombre</div>
                            <input
                                value={Name}
                                className="LandingInnerInputTile"
                                style={{ borderBottom: validation["Name"] === "invalid" ? "red solid 1px" : Name.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Name"] === "invalid" ? "#FFFAEA" : Name.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                                id="YMCName"
                                maxLength={70}
                                onChange={(e) => handleName(e.target.value)}
                                placeholder="--" />
                                {validation["Name"] === "invalid" ?
                                    <div className='LandingInnerAlert'> Por favor ingrese nombre válido</div>
                                : null}
                            <div className='LandingInnerSixthBlockRightInputTitle'>Nombre de tu empresa</div>
                            <input
                                value={Company}
                                className="LandingInnerInputTile"
                                style={{ borderBottom: validation["Company"] === "invalid" ? "red solid 1px" : Company.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Company"] === "invalid" ? "#FFFAEA" : Company.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                                id="YMCCompany"
                                maxLength={70}
                                onChange={(e) => setCompany(e.target.value)}
                                placeholder="--" />
                                {validation["Company"] === "invalid" ?
                                    <div className='LandingInnerAlert'> Por favor ingrese nombre válido de compañía</div>
                                : null}
                            <div className='LandingInnerSixthBlockRightInputTitle'>Cantidad de Trabajadores</div>
                            <input
                                value={Workers}
                                className="LandingInnerInputTile"
                                style={{ borderBottom: validation["Workers"] === "invalid" ? "red solid 1px" : Workers.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Workers"] === "invalid" ? "#FFFAEA" : Workers.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                                id="YMCWorkers"
                                onChange={(e) => handleChange(e.target.value,setWorkers)}
                                placeholder="--" />
                                {validation["Workers"] === "invalid" ?
                                    <div className='LandingInnerAlert'> Por favor ingrese un número válido</div>
                                : null}
                            <div className='LandingInnerSixthBlockRightInputTitle'>Correo electrónico</div>
                            <input
                                value={Email}
                                className="LandingInnerInputTile"
                                style={{ borderBottom: validation["Email"] === "invalid" ? "red solid 1px" : Email.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Email"] === "invalid" ? "#FFFAEA" : Email.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                                id="YMCEmail"
                                maxLength={70}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="--" />
                                {validation["Email"] === "invalid" ?
                                    <div className='LandingInnerAlert'> Por favor ingrese correo válido</div>
                                : null}
                            <div className='LandingInnerSixthBlockRightInputTitle'>Teléfono de contacto</div>
                            <input
                                value={Phone}
                                className="LandingInnerInputTile"
                                style={{ borderBottom: validation["Phone"] === "invalid" ? "red solid 1px" : Phone.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Phone"] === "invalid" ? "#FFFAEA" : Phone.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                                id="YMCPhone"
                                maxLength={20}
                                type="tel"
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder="Tel +56" />
                                {validation["Phone"] === "invalid" ?
                                    <div className='LandingInnerAlert'> Por favor ingrese teléfono válido</div>
                                : null}
                            {TaskStart ?
                            <div className='GeneralPurpleButtonFlex LandingInnerSixthBlockSendButton LandingInnerSixthBlockSendButtonDisabled'>
                                Enviando...
                            </div>
                            : TaskDone ?
                            <div className='GeneralPurpleButtonFlex LandingInnerSixthBlockSendButton LandingInnerSixthBlockSendButtonDisabled'>
                                Enviado
                            </div>
                            :
                            <div className='GeneralPurpleButtonFlex LandingInnerSixthBlockSendButton' onClick={() => verifyContact()}>
                                Enviar<div className='triangle'><i className='innerarrowWhite'></i></div>
                            </div>
}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Landing;